import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { XCircle, ArrowLeft } from "lucide-react";

const PaymentCancel = () => {
  return (
    <div className="min-h-screen bg-[#08080a] flex items-center justify-center px-5">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="glass rounded-3xl p-10 md:p-14 max-w-md w-full text-center border border-white/8"
      >
        <XCircle size={64} className="text-white/50 mx-auto" />
        <h1 className="font-display font-bold text-2xl text-white mt-6">Paiement annulé</h1>
        <p className="text-white/60 mt-3">
          Aucun montant n'a été prélevé. Vous pouvez reprendre votre inscription
          quand vous le souhaitez.
        </p>
        <Link to="/" className="btn-racing mt-8 inline-flex justify-center">
          <ArrowLeft size={16} /> Retour à l'accueil
        </Link>
      </motion.div>
    </div>
  );
};

export default PaymentCancel;
